import apiClient from '@u/apiClient'
import CreateBankController from '@/wayfinder/actions/App/Http/Controllers/Banks/CreateBankController'

export default {
  // region store
  /**
   * Adds a bank to the shared list. The API answers the whole list and the bank
   * created (or the one that already had that name), so the list in the metadata
   * is replaced and the bank is handed back to be picked.
   */
  storeNewBank: ({ commit }, payload) => {
    return apiClient
      .route(CreateBankController.post(), { name: payload.name })
      .then((response) => {
        if (response.data?.banks) {
          commit(
            'metadata/setSpecificMetadataModels',
            { model: 'banks', data: response.data.banks },
            { root: true }
          )
        }
        return response.data?.bank ?? null
      })
  }
  //end region
}
